export const AppConfig = {
    refreshTimeout: 30,
    userIdleExpiryTimeInMins: 30,
    apiTokenKey: "konsole-token",
    refreshTokenKey: "konsole-refresh-token",
    lastActivityKey: "konsole-last-activity",
    lastTimeTriggered: "lastTimeTriggered",
};